import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/orders',
      name: 'orders',
      component: () => import(/* webpackChunkName: "orders" */ './views/PackagingOverview.vue'),
      alias: "/"
    },

    {
      path: '/orders/new',
      name: 'create-order',
      component: () => import(/* webpackChunkName: "orders" */ './views/BuildOrder.vue')
    },

    {
      path: '/orders/modify/:number',
      name: 'edit-order',
      component: () => import(/* webpackChunkName: "order" */ './views/BuildOrder.vue')
    },

    { path: '/orders/modify', redirect: { name: "orders"} },
    

    {
      path: '/shift-report',
      name: 'shiftreport',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "shiftreport" */ './views/ShiftReport.vue')
    },
    {
      path: '/orders/:number',
      name: 'order',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "order" */ './views/WorkOrder.vue')
    },
    
  ]
})
